import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import Nav from './Header.Styled';
import useClickOutside from '../../hooks/useClickOutside';

const Header = ({ siteTitle }) => {
  const [navDropdown, setnavDropdown] = useState(false);
  const navDropdownclick = useCallback((value) => (e) => {
    if (e) e.preventDefault();
    setnavDropdown((state) => (state === value ? null : value));
  });

  const { reference: navContainer } = useClickOutside(() => {
    if (navDropdown) setnavDropdown(false);
  });

  return (
    <header>
      <Nav>
        <div className="header-top"></div>
        <div
          ref={navContainer}
          className={`side-bar-main ${navDropdown ? 'dropdown-open' : ''}`}>
          <ul className="siderbar-nav-contents">
            <li className="logo-area">
              <Link to="/">
                <img src="/img/makestories-logo.svg" alt="makestories" />
              </Link>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="18"
                fill="none"
                viewBox="0 0 20 18">
                <path
                  fill="#000"
                  d="M.293 8.293l4-4a1 1 0 111.414 1.414L3.414 8H15a1 1 0 110 2H3.414l2.293 2.293a1 1 0 11-1.414 1.414l-4-4a1 1 0 010-1.414zM18 1v16a1 1 0 002 0V1a1 1 0 00-2 0z"
                />
              </svg>
            </li>

            <li
              className={`position-relative ${
                navDropdown === 1 ? 'show-dropdown' : ''
              }`}>
              <a href="#!" onClick={navDropdownclick(1)} className="nav-user">
                <span className="nav-profile">TW</span>
                <span className="hidden-text">Test Workspace</span>
              </a>

              <div className="user-dropdown">
                <a href="#!" className="flex-row no-margin align-items-center">
                  <span className="nav-profile" style={{ marginRight: 15 }}>
                    TW
                  </span>
                  <div>
                    <p>Test WorkSpace</p>
                    <span>Members: 10</span>
                  </div>
                </a>
                <a href="#!" className="flex-row no-margin align-items-center">
                  <span
                    className="nav-profile"
                    style={{
                      backgroundColor: '#FFFAF0',
                      color: '#C98600',
                      marginRight: 15,
                    }}>
                    HB
                  </span>
                  <div>
                    <p>Hybreed</p>
                    <span>Members: 3</span>
                  </div>
                </a>
                <a href="#!" className="flex-row no-margin align-items-center">
                  <span className="nav-profile" style={{ marginRight: 15 }}>
                    <img src="/img/dribbble.svg" alt="" />
                  </span>
                  <div>
                    <p>Test WorkSpace</p>
                    <span>Members: 10</span>
                  </div>
                </a>

                <Link to="/workspaces/" className="link">
                  View All
                </Link>
              </div>
            </li>

            <li>
              <a href="#!" className="new-story-button">
                <span className="story-icon">
                  <svg width="12" height="12" fill="none" viewBox="0 0 12 12">
                    <path
                      fill="#fff"
                      fillRule="evenodd"
                      d="M5.111 5.111V1.556a.889.889 0 011.778 0V5.11h3.555a.889.889 0 010 1.778H6.89v3.555a.889.889 0 01-1.778 0V6.89H1.556a.889.889 0 010-1.778H5.11z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
                <span className="hidden-text">Create New Story</span>
              </a>
            </li>

            <li
              className={`nav-dropdown ${
                navDropdown === 2 ? 'show-dropdown' : ''
              }`}>
              <a href="#!" className="nav-link" onClick={navDropdownclick(2)}>
                <span className="nav-icon">
                  <svg width="22" height="16" fill="none" viewBox="0 0 22 16">
                    <path
                      d="M21 0H1a1 1 0 00-1 1v6a1 1 0 001 1h20a1 1 0 001-1V1a1 1 0 00-1-1zm-1 6H2V2h18v4zm2 5a1 1 0 01-1 1H1a1 1 0 010-2h20a1 1 0 011 1zm0 4a1 1 0 01-1 1H1a1 1 0 010-2h20a1 1 0 011 1z"
                      opacity=".52"
                    />
                  </svg>
                </span>
                <span className="hidden-text">Stories</span>
              </a>
              <div className="nav-dropdown-menu">
                <Link to="/">My Stories</Link>
                <Link to="/">Shared with me</Link>
                <Link to="/">Trash</Link>
              </div>
            </li>
            <li>
              <a href="#!" className="nav-link">
                <span className="nav-icon">
                  <svg width="18" height="22" fill="none" viewBox="0 0 18 22">
                    <path
                      d="M17 22a1 1 0 001-1V1a1 1 0 00-1-1H1a1 1 0 00-1 1v20a1 1 0 001 1h16zm-1-2H2v-8h14v8zM2 2h14v8H2V2zm4 13a1 1 0 011-1h4a1 1 0 010 2H7a1 1 0 01-1-1zm6-10a1 1 0 01-1 1H7a1 1 0 010-2h4a1 1 0 011 1z"
                      opacity=".5"
                    />
                  </svg>
                </span>
                <span className="hidden-text">Libraries</span>
              </a>
            </li>
            <li>
              <a href="#!" className="nav-link">
                <span className="nav-icon">
                  <svg width="23" height="23" fill="none" viewBox="0 0 23 23">
                    <path
                      d="M19.192 8.5a1 1 0 00-1.415 0l-5.859 5.859a2.314 2.314 0 01-3.273-3.272L14.5 5.223a.999.999 0 000-1.415L10.989.293a1 1 0 00-1.415 0L3.715 6.152a9.287 9.287 0 0013.133 13.133l5.859-5.859a1 1 0 000-1.415L19.192 8.5zm-8.91-6.081l2.1 2.1-1.514 1.512-2.1-2.1 1.514-1.512zm5.152 15.451a7.286 7.286 0 01-10.3-10.3l2.218-2.226 2.1 2.1-2.221 2.224a4.314 4.314 0 006.1 6.1l2.222-2.222 2.1 2.1-2.219 2.224zm3.636-3.636l-2.1-2.1 1.515-1.515 2.1 2.1-1.515 1.515z"
                      opacity=".52"
                    />
                  </svg>
                </span>
                <span className="hidden-text">Lead Generation</span>
              </a>
            </li>
            <li>
              <a href="#!" className="nav-link">
                <span className="nav-icon">
                  <svg width="22" height="18" fill="none" viewBox="0 0 22 18">
                    <path
                      d="M19 0H3a3 3 0 00-3 3v12a3 3 0 003 3h16a3 3 0 003-3V3a3 3 0 00-3-3zm1 15a1 1 0 01-1 1H3a1 1 0 01-1-1V3a1 1 0 011-1h16a1 1 0 011 1v12zM8 9v4a1 1 0 11-2 0V9a1 1 0 012 0zm4-2v6a1 1 0 01-2 0V7a1 1 0 012 0zm4-2v8a1 1 0 01-2 0V5a1 1 0 012 0z"
                      opacity=".52"
                    />
                  </svg>
                </span>
                <span className="hidden-text">Page Attachment</span>
              </a>
            </li>
            <li
              className={`nav-dropdown ${
                navDropdown === 3 ? 'show-dropdown' : ''
              }`}>
              <a href="#!" className="nav-link" onClick={navDropdownclick(3)}>
                <span className="nav-icon">
                  <svg width="18" height="22" fill="none" viewBox="0 0 18 22">
                    <path
                      d="M17 22a1 1 0 001-1V1a1 1 0 00-1-1H1a1 1 0 00-1 1v20a1 1 0 001 1h16zm-1-2H2v-8h14v8zM2 2h14v8H2V2zm4 13a1 1 0 011-1h4a1 1 0 010 2H7a1 1 0 01-1-1zm6-10a1 1 0 01-1 1H7a1 1 0 010-2h4a1 1 0 011 1z"
                      opacity=".5"
                    />
                  </svg>
                </span>
                <span className="hidden-text">Analytics</span>
              </a>
              <div className="nav-dropdown-menu">
                <Link to="/">My Stories</Link>
                <Link to="/">Shared with me</Link>
                <Link to="/">Trash</Link>
              </div>
            </li>
            <li>
              <a href="#!" className="nav-link">
                <span className="nav-icon">
                  <svg width="22" height="22" fill="none" viewBox="0 0 22 22">
                    <path
                      d="M11 7a4 4 0 100 8 4 4 0 000-8zm0 6a2 2 0 110-4 2 2 0 010 4zm8.99-5h-1.575c-.008-.022-.036-.107-.046-.129l1.11-1.11a2.011 2.011 0 000-2.842l-1.4-1.4a2 2 0 00-1.421-.588 2 2 0 00-1.419.588L14.07 3.612 14 3.58V2.009A2.01 2.01 0 0011.99 0h-1.98A2.011 2.011 0 008 2.009v1.557l-.086.049-.043.016-1.106-1.109a2 2 0 00-1.42-.589 2 2 0 00-1.421.588l-1.4 1.4a2.011 2.011 0 000 2.842l1.1 1.143c-.013.029-.033.063-.043.093H2.01A2.011 2.011 0 000 10.009v1.982A2.01 2.01 0 002.01 14h1.575c.008.022.036.107.046.129l-1.11 1.11a2.011 2.011 0 000 2.842l1.4 1.4a2.06 2.06 0 002.842 0l1.115-1.115.121.056v1.571A2.011 2.011 0 0010.01 22h1.98A2.01 2.01 0 0014 19.991v-1.557l.129-.065 1.109 1.109a2.058 2.058 0 002.843 0l1.4-1.4a2.011 2.011 0 000-2.842l-1.1-1.143c.013-.029.033-.063.043-.093h1.566A2.01 2.01 0 0022 11.991v-1.982A2.01 2.01 0 0019.99 8zm0 4h-1.569a2.1 2.1 0 00-1.466 3.54l1.109 1.124-1.414 1.4-1.11-1.109A2.1 2.1 0 0012 18.42L11.99 20 10 19.991V18.42a2.043 2.043 0 00-1.307-1.881 2.138 2.138 0 00-.816-.164 2 2 0 00-1.417.58l-1.124 1.109-1.4-1.414 1.108-1.108A2.1 2.1 0 003.579 12L2 11.991 2.01 10h1.569a2.1 2.1 0 001.466-3.54L3.936 5.336l1.414-1.4 1.11 1.109a2.04 2.04 0 002.227.419l.018-.007A2.04 2.04 0 0010 3.58L10.01 2l1.99.009V3.58a2 2 0 001.227 1.845 2.038 2.038 0 002.313-.38l1.124-1.109 1.4 1.414-1.108 1.108A2.1 2.1 0 0018.421 10h1.569l.01.009L19.99 12z"
                      opacity=".52"
                    />
                  </svg>
                </span>
                <span className="hidden-text">Settings</span>
              </a>
            </li>

            <li>
              <a href="#!" className="bottom-bandwidth">
                <span className="bandwidth-icon">
                  <svg width="22" height="22" fill="none" viewBox="0 0 22 22">
                    <path
                      fill="#252525"
                      d="M11 0a11 11 0 1011 11A11.013 11.013 0 0011 0zM2 11a9.011 9.011 0 018-8.941v8.527l-6.025 6.025A8.948 8.948 0 012 11zm9 9c-2.04 0-4.02-.696-5.611-1.975L11.414 12h8.527A9.01 9.01 0 0111 20zm1-10V2.059A9.013 9.013 0 0119.941 10H12z"
                      opacity=".52"
                    />
                  </svg>
                </span>
                <div className="bandwidth-block">
                  <p>Bandwidth</p>

                  <div className="bandwidth-progress">
                    <span className="progress" style={{ width: '56%' }}></span>
                  </div>
                  <div className="flex-row no-margin justify-space-between">
                    <p>0 MB</p>
                    <p>5 TB</p>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </Nav>
    </header>
  );
};
Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: `Makestories`,
};

export default Header;
